'use strict';

export const JobQuoteIdType = {
  JobQuote: 'JobQuote',
  Lead: 'Lead'
};

export const TABS = {
  'PROFILE': 'PROFILE',
  'NOTES': 'NOTES',
  'DOCS': 'DOCS'
};

